var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AgreementPop',{attrs:{"show":_vm.show,"value":_vm.value,"title":"共享经济合作伙伴协议","checkText":"我已阅读并确认协议"},on:{"input":_vm.handleAgree,"confirm":_vm.handleConfirm,"close":_vm.handleClose}},[_c('Protocol')],1)}
var staticRenderFns = []

export { render, staticRenderFns }